import React from 'react';

export const defaultValues = {
  "price": 300000,
  "asIsValue": 300000,
  "constructionBudget": 50000,
  "afterRepairValue": 425000,
  "monthlyRent": 2500,
  "annualTaxes": 4000,
  "annualInsurance": 3000,
  "annualHoa": 0,
  "currentLoanBalance": 220000
}

export const rentalInputs = [
  {
    labelText: "Estimated monthly rental income",
    label: <React.Fragment>Estimated <b>monthly</b> rental income</React.Fragment>,
    customKey: "monthlyRent"
  },
  {
    labelText: "Estimated annual property taxes",
    label: <React.Fragment>Estimated <b>annual</b> property taxes</React.Fragment>,
    customKey: "annualTaxes"
  },
  {
    labelText: "Estimated annual property insurance",
    label: <React.Fragment>Estimated <b>annual</b> property insurance</React.Fragment>,
    customKey: "annualInsurance"
  },
  {
    labelText: "Estimated annual HOA fee",
    label: <React.Fragment>Estimated <b>annual</b> HOA fee</React.Fragment>,
    customKey: "annualHoa"
  },
]

export const PROGRAMS = [
  { key: "optimize", label: "Optimize" },
  { key: "standard", label: "Standard" },
  { key: "expanded", label: "Expanded" },
  { key: "plus", label: "Plus" },
  { key: "flex", label: "Flex" }
]

